/**
 * Extract the host portion from a `staticAddresses[N]` value, which may be:
 *   - `1.2.3.4:4242`        (IPv4)
 *   - `[2001:db8::1]:4242`  (bracketed IPv6)
 *   - `lighthouse.example:4242` (hostname)
 *
 * Plain `split(':')[0]` corrupts IPv6 literals (returns `[`), so bracketed
 * forms are matched separately.
 */
export function parsePublicIPOrHostname(staticAddress: string | undefined): string {
  if (!staticAddress) return '';
  if (staticAddress.startsWith('[')) {
    return /^\[([^\]]+)\]/.exec(staticAddress)?.[1] ?? '';
  }
  return staticAddress.split(':')[0] ?? '';
}
